import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import SiteFooter from "@/components/SiteFooter";
import "@/voteforme.css";

const LOGO_WHITE = "/sbgwc-logo-white.png";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="vfm admin-wrap"><div className="vfm-bg-glow" />
      <div className="admin-center">
        <form className="admin-login-card" onSubmit={submit}>
          <img src={LOGO_WHITE} alt="SBGWC" style={{ height: 44, marginBottom: 22 }} />
          <div className="screen-label">Organizer Access</div>
          <h1 className="admin-title" style={{ marginBottom: 20 }}>Admin Login</h1>
          <div className="input-group" style={{ marginBottom: 14 }}>
            <label className="input-label">Email</label>
            <input className="text-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@…" required data-testid="admin-login-email" style={{ fontSize: 15 }} />
          </div>
          <div className="input-group" style={{ marginBottom: 20 }}>
            <label className="input-label">Password</label>
            <input className="text-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required data-testid="admin-login-password" style={{ fontSize: 15 }} />
          </div>
          <button className="btn-primary" type="submit" disabled={busy} style={{ width: "100%" }} data-testid="admin-login-submit">
            {busy ? "Signing in…" : "Sign In"}
          </button>
          {error && <div className="err-text" data-testid="admin-login-error">{error}</div>}
        </form>
      </div>
      <SiteFooter />
    </div>
  );
}
